import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        padding: isHosTheme ? '13px 20px' : '40px',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        gap: '40px',
        background: isHosTheme ? theme.palette.common.white : theme.palette.common.black,
        [theme.breakpoints.up('lg')]: {
            padding: isHosTheme ? '13px 50px' : '40px',
        },
    }),
    rightSideHos: css({
        width: '100%',
        display: 'flex',
        columnGap: '12px',
        color: theme.palette.common.black,
    }),
    slash: css({
        color: theme.palette.primary.light,
    }),
    leftSide: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        maxWidth: '252px',
        color: theme.palette.common.white,
    }),
    rightSide: css({
        width: '100%',
        marginTop: '36px',
        borderTop: `1px solid ${theme.palette.grey[500]}`,
        paddingTop: '20px',
        display: 'flex',
        columnGap: '12px',
        flexWrap: 'wrap',
        maxWidth: '443px',
        color: theme.palette.common.white,
    }),
    link: css({
        cursor: 'pointer',
        textDecoration: 'none',
        color: 'inherit',
        ':hover': {
            textDecoration: 'underline',
        },
    }),
};
